import { useSelector } from "react-redux";

const IsSeeker = ({ children }) => {
  const { type } = useSelector((state) => state.user);
  return type === "seeker" ? children : null;
};

export default IsSeeker;
